"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayButton = exports.Sum = exports.DetailPrice = exports.DetailName = exports.Detail = exports.DetailsWrap = exports.FooterWrap = exports.CartTitle = exports.CartContent = exports.Description = exports.Title = exports.FlexWrap = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.FlexWrap = app_1.styled.div `
  ${(theme) => theme.flexCenter}
  flex: 1;
  flex-direction: column;
  padding: 0 ${(theme) => theme.spacing.small};
`;
exports.Title = (0, app_1.styled)(app_1.Text) `
  font-weight: bold;
  text-align: center;
  padding-top: ${(theme) => theme.spacing.small};
`;
exports.Description = (0, app_1.styled)(app_1.Text) `
  padding: ${(theme) => `${theme.spacing.small} ${theme.spacing.medium}`};
  text-align: center;
`;
exports.CartContent = app_1.styled.div `
  padding: 0 ${(theme) => theme.spacing.small};
  flex: 1;
`;
exports.CartTitle = (0, app_1.styled)(app_1.Text) `
  font-size: 1.5rem;
  font-weight: normal;
`;
exports.FooterWrap = app_1.styled.div `
  flex-shrink: 0;
  padding: ${(theme) => theme.spacing.small};
  position: sticky;
  z-index: 20;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  background: ${(theme) => theme.background};
  @media ${app_1.mobile} {
    padding: ${(theme) => theme.spacing.extraSmall};
  }
`;
exports.DetailsWrap = app_1.styled.div `
  border-bottom: 1px solid ${(theme) => theme.stroke};
  display: flex;
  flex-direction: column;
  padding-bottom: ${(theme) => theme.spacing.small};
  margin-bottom: ${(theme) => theme.spacing.small};

  @media ${app_1.mobile} {
    margin-bottom: ${(theme) => theme.spacing.extraSmall};
    padding-bottom: ${(theme) => theme.spacing.extraSmall};
  }
`;
exports.Detail = app_1.styled.div `
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: calc(${(theme) => theme.spacing.small} / 2) 0;
`;
exports.DetailName = app_1.styled.span ``;
exports.DetailPrice = app_1.styled.span `
  text-align: end;
`;
exports.Sum = (0, app_1.styled)(exports.Detail) `
  font-size: 1.5rem;
  letter-spacing: 2px;
`;
exports.PayButton = (0, app_1.styled)(ui_1.Button) `
  border-radius: 0;
  text-transform: uppercase;
  width: 100%;
  height: 4rem;
  margin-top: ${(theme) => theme.spacing.medium};
  @media ${app_1.mobile} {
    margin-top: ${(theme) => theme.spacing.extraSmall};
  }
`;
